module.exports = __webpack_public_path__ + "static/img/music-home-default.502726a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/music-home-default.png
// module id = A31P
// module chunks = 0